//

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import ConfirmPassword from "layouts/authentication/confirmPassword";

// @mui icons
import Icon from "@mui/material/Icon";
import Expenses from "layouts/expenses";
import Groupes from "layouts/groups";
import Exposure from "layouts/exposure";

const routes = [
  {
    type: "collapse",
    name: "Data",
    key: "dashboard",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/dashboard",
    component: <Tables />,
    protected: true,
  },
  {
    type: "collapse",
    name: "Exposure",
    key: "exposure",
    icon: <Icon fontSize="small">account_balance_wallet</Icon>,
    route: "/exposure",
    component: <Exposure />,
    protected: true,
  },
  // {
  //   type: "collapse",
  //   name: "Dashboard",
  //   key: "dashboard",
  //   icon: <Icon fontSize="small">dashboard</Icon>,
  //   route: "/dashboard",
  //   component: <Dashboard />,
  //   protected: true,
  // },

  {
    type: "collapse",
    name: "Expenses",
    key: "expenses",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/expenses",
    component: <Expenses />,
    protected: true,
  },
  {
    type: "collapse",
    name: "Groups",
    key: "groups",
    icon: <Icon fontSize="small">groupes</Icon>,
    route: "/groups",
    component: <Groupes />,
    protected: true,
  },
  // {
  //   type: "collapse",
  //   name: "RTL",
  //   key: "rtl",
  //   icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
  //   route: "/rtl",
  //   component: <RTL />,
  //   protected: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">notifications</Icon>,
  //   route: "/notifications",
  //   component: <Notifications />,
  //   protected: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/profile",
  //   component: <Profile />,
  //   protected: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Sign In",
  //   key: "sign-in",
  //   icon: <Icon fontSize="small">login</Icon>,
  //   route: "/authentication/sign-in",
  //   component: <SignIn />,
  //   protected: false,
  // },
  // {
  //   type: "collapse",
  //   name: "Sign Up",
  //   key: "sign-up",
  //   icon: <Icon fontSize="small">assignment</Icon>,
  //   route: "/authentication/sign-up",
  //   component: <SignUp />,
  //   protected: false,
  // },
  // {
  //   type: "collapse",
  //   name: "Confirm Password",
  //   key: "confirmPassword",
  //   icon: <Icon fontSize="small">assignment</Icon>,
  //   route: "/authentication/confirmePassword",
  //   component: <ConfirmPassword />,
  //   protected: false,
  // },
];

export default routes;
